import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOptionWithApiParams } from "../types";
import { FormSelectPaywall } from "./shared/FormSelectPaywall";
import {
  type CancelSubscriptionApiParams,
  HistoryDetailViewPaywall,
  type HistoryDetailViewPaywallProps,
} from "./shared/HistoryDetailViewPaywall";
import { ViewCancelSubscription } from "./shared/ViewCancelSubscription";

export const cancelSubscriptionImmediately: Readonly<
  ActionOptionWithApiParams<
    HistoryDetailViewPaywallProps,
    CancelSubscriptionApiParams
  >
> = {
  label: t(
    "settings.workflows.form.actions.cancel_community_member_paywall_subscription_immediately",
  ),
  value: "cancel_community_member_paywall_subscription_immediately",
  group: t("settings.workflows.form.action_groups.paywall"),
  leftAddon: <Icon type="16-remove-paywall" size={16} className="!h-4 !w-4" />,
  formComponent: FormSelectPaywall,
  viewComponent: ViewCancelSubscription,
  historyDetailViewComponent: HistoryDetailViewPaywall,
  isApplicableToMembersOnly: true,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.HIGHER_TIER_PLAN_ONLY,
} as const;
